import React from "react";


import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileProtect } from "react-icons/ai";
import { AiOutlineUserSwitch } from "react-icons/ai";
import { AiOutlineBank } from "react-icons/ai";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { RiLuggageDepositLine } from "react-icons/ri";
import { GiHamburgerMenu } from "react-icons/gi";

import { FcNeutralTrading } from "react-icons/fc";
import { MdOutlineCalculate } from "react-icons/md";
import { FaUniversity } from "react-icons/fa";
import { TfiWallet } from "react-icons/tfi";
import { RiHandCoinLine } from "react-icons/ri";

import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';

export async function getServerSideProps(context) {
  const path = context.resolvedUrl.toLowerCase();

  const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

  const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

  const title = matchedMeta?.title || 'Millance';
  const description = matchedMeta?.description || 'Trade smarter with Millance.';
  const url = matchedMeta?.url || `https://millance.com${path}`;
  const jsonLd =  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What are the different account types offered by Millance?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Millance offers Standard, ECN, and Pro accounts to suit various trading styles and experience levels."
        }
      },
      {
        "@type": "Question",
        "name": "How can I fund my Millance trading account?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You can fund your account through multiple options including bank transfer, credit/debit card, and e-wallets."
        }
      },
      {
        "@type": "Question",
        "name": "What tools are available for traders on Millance?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Millance provides MetaTrader 5, pip calculators, risk management tools, and market analysis insights."
        }
      }
    ]
  }

  return {
    props: { meta: { title, description, url }, jsonLd, }
  };
}
const Faq2 = ({ meta, jsonLd }) => {

  return (
    <>
      <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
      <div className="faqm2">
        <section className="faq-banner">
          <div className="faqcont">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 col-lg-6 d-flex flex-column justify-content-center mt-5">
                  <h1 className="mt-5">Frequently Asked Questions (FAQ)</h1>
                  <p className=" mb-3">
                    Find clear and concise answers to the most commonly asked questions about Millance LTD in our comprehensive FAQ section.
                  </p>
                </div>
                <div className="col-md-12 col-lg-6">
                  <img
                    src={"/images/faq/faqbanner.png"}
                    alt="logo"
                    className="img-fluid mt-5"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="faqsidebar px-0">
          <div className="container-fluid">
            <div className="row flex-nowrap">
              <div className="col-auto px-0">
                <div className="col-lg-8 col-md-12 col-sm-12">
                  <div
                    id="sidebar"
                    className="collapse collapse-horizontal show "
                  >
                    <div
                      id="sidebar-nav"
                      className="list-group border-0 rounded-0 text-sm-start min-vh-100"
                    >
                      <ul
                        className="nav  nav-pills p-0 "
                        id="pills-tab"
                        role="tablist"
                      >
                        <li
                          className="nav-link active"
                          id="pills-1-tab"
                          data-bs-toggle="pill"
                          href="#pills-1"
                          role="tab"
                          aria-controls="pills-1"
                          aria-selected="true"
                        >
                          <span className=" name ">
                            <h2>Get Started</h2>
                            <button  type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse1"
                             
                              aria-controls="collapse1">

                            <h6
                              className="accordion-button"
                             
                              >
                              <span className="icon">
                                <AiOutlineUserAdd />
                              </span>
                              General
                            </h6>
                              </button>
                            <ul
                              id="collapse1"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading1"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>

                        {/* accrodion one --------------end */}

                        <li
                          className="nav-link"
                          id="pills-2-tab"
                          data-bs-toggle="pill"
                          href="#pills-2"
                          role="tab"
                          aria-controls="pills-2"
                          aria-selected="false"
                        >
                          <span className="name  ">
                            <button  type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse2"
                             
                              aria-controls="collapse2">

                            <h6
                              className="accordion-button"
                             
                              >
                              {" "}
                              <span className="icon">
                                <AiOutlineFileProtect />
                              </span>
                              Registration
                            </h6>
                              </button>
                            <ul
                              id="collapse2"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading2"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>
                        {/* accrodion two --------------end */}

                        <li
                          className="nav-link"
                          id="pills-3-tab"
                          data-bs-toggle="pill"
                          href="#pills-3"
                          role="tab"
                          aria-controls="pills-3"
                          aria-selected="false"
                        >
                          <span className=" name">
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse3"
                             
                              aria-controls="collapse3"
                            >
                              <span className="icon">
                                <AiOutlineUserSwitch />
                              </span>
                              Trading
                            </h6>
                            <ul
                              id="collapse3"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading3"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>

                        {/* accrodion three --------------end */}

                        <li
                          className="nav-link"
                          id="pills-4-tab"
                          data-bs-toggle="pill"
                          href="#pills-4"
                          role="tab"
                          aria-controls="pills-4"
                          aria-selected="false"
                        >
                          <span className=" name">
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse4"
                             
                              aria-controls="collapse4"
                            >
                              <span className="icon">
                                <AiOutlineBank />
                              </span>
                              Trading Service
                            </h6>
                            <ul
                              id="collapse4"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading4"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>

                        {/* accrodion four --------------end */}

                        <li
                          className="nav-link"
                          id="pills-5-tab"
                          data-bs-toggle="pill"
                          href="#pills-5"
                          role="tab"
                          aria-controls="pills-5"
                          aria-selected="false"
                        >
                          <span className=" name">
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse5"
                             
                              aria-controls="collapse5"
                            >
                              {" "}
                              <span className="icon">
                                <MdOutlineAccountBalanceWallet />
                              </span>
                              Placing Trade
                            </h6>
                            <ul
                              id="collapse5"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading5"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>

                        {/* accrodion five --------------end */}

                        <li
                          className="nav-link"
                          id="pills-6-tab"
                          data-bs-toggle="pill"
                          href="#pills-6"
                          role="tab"
                          aria-controls="pills-6"
                          aria-selected="false"
                        >
                          <span className="name">
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse6"
                             
                              aria-controls="collapse6"
                            >
                              <span className="icon">
                                <RiLuggageDepositLine />
                              </span>
                              Trading Account
                            </h6>
                            <ul
                              id="collapse6"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading6"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>

                        {/* accrodion six --------------end */}

                        <li
                          className="nav-link"
                          id="pills-7-tab"
                          data-bs-toggle="pill"
                          href="#pills-7"
                          role="tab"
                          aria-controls="pills-7"
                          aria-selected="false"
                        >
                          <span className=" name">
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse6"
                             
                              aria-controls="collapse6"
                            >
                              {" "}
                              <span className="icon">
                                <FcNeutralTrading />
                              </span>
                              Trading Symbol
                            </h6>
                            <ul
                              id="collapse6"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading6"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>
                        {/* accrodion seven --------------end */}
                        <li
                          className="nav-link"
                          id="pills-8-tab"
                          data-bs-toggle="pill"
                          href="#pills-8"
                          role="tab"
                          aria-controls="pills-8"
                          aria-selected="false"
                        >
                          <span className="name  ">
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse8"
                             
                              aria-controls="collapse8"
                            >
                              {" "}
                              <span className="icon">
                                <FaUniversity />
                              </span>{" "}
                              Trading account information
                            </h6>
                            <ul
                              id="collapse8"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading8"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>

                        {/* accrodion eight --------------end */}
                        <li
                          className="nav-link"
                          id="pills-9-tab"
                          data-bs-toggle="pill"
                          href="#pills-9"
                          role="tab"
                          aria-controls="pills-9"
                          aria-selected="false"
                        >
                          <span className="name  ">
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse9"
                             
                              aria-controls="collapse9"
                            >
                              {" "}
                              <span className="icon">
                                <MdOutlineCalculate />
                              </span>{" "}
                              Calculations
                            </h6>
                            <ul
                              id="collapse9"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading9"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>
                        {/* accrodion nine --------------end */}
                        <li
                          className="nav-link"
                          id="pills-10-tab"
                          data-bs-toggle="pill"
                          href="#pills-10"
                          role="tab"
                          aria-controls="pills-10"
                          aria-selected="false"
                        >
                          <span className="name  ">
                            <h2>Deposits and Withdrawals</h2>
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse10"
                             
                              aria-controls="collapse10"
                            >
                              {" "}
                              <span className="icon">
                                <AiOutlineUserAdd />
                              </span>{" "}
                              General
                            </h6>
                            <ul
                              id="collapse10"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading10"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>
                        {/* accrodion ten --------------end */}
                        <li
                          className="nav-link"
                          id="pills-11-tab"
                          data-bs-toggle="pill"
                          href="#pills-11"
                          role="tab"
                          aria-controls="pills-11"
                          aria-selected="false"
                        >
                          <span className="name  ">
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse11"
                             
                              aria-controls="collapse11"
                            >
                              {" "}
                              <span className="icon">
                                <TfiWallet />
                              </span>
                              Making Deposit
                            </h6>
                            <ul
                              id="collapse11"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading11"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>
                        {/* accrodion ten --------------end */}
                        <li
                          className="nav-link"
                          id="pills-12-tab"
                          data-bs-toggle="pill"
                          href="#pills-12"
                          role="tab"
                          aria-controls="pills-12"
                          aria-selected="false"
                        >
                          <span className="name  ">
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse12"
                             
                              aria-controls="collapse12"
                            >
                              {" "}
                              <span className="icon">
                                <RiHandCoinLine />
                              </span>
                              Withdrawals
                            </h6>
                            <ul
                              id="collapse12"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading12"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>

                        {/* accrodion 11 --------------end */}
                        <li
                          className="nav-link"
                          id="pills-13-tab"
                          data-bs-toggle="pill"
                          href="#pills-13"
                          role="tab"
                          aria-controls="pills-13"
                          aria-selected="false"
                        >
                          <span className="name  ">
                            <h2>Partnership Program</h2>
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse13"
                             
                              aria-controls="collapse13"
                            >
                              {" "}
                              <span className="icon">
                                <AiOutlineUserAdd />
                              </span>{" "}
                              General
                            </h6>
                            <ul
                              id="collapse13"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading13"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>

                        <li
                          className="nav-link"
                          id="pills-14-tab"
                          data-bs-toggle="pill"
                          href="#pills-14"
                          role="tab"
                          aria-controls="pills-14"
                          aria-selected="false"
                        >
                          <span className="name  ">
                            <h2>Platform</h2>
                            <h6
                              className="accordion-button"
                              type=""
                              data-bs-toggle="collapse"
                              data-bs-target="#collapse14"
                             
                              aria-controls="collapse14"
                            >
                              {" "}
                              <span className="icon">
                                <AiOutlineUserAdd />
                              </span>{" "}
                              General
                            </h6>
                            <ul
                              id="collapse14"
                              className="accordion-collapse collapse hide  "
                              aria-labelledby="heading14"
                              data-bs-parent="#accordionExample"
                            ></ul>
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <main className="col ps-md-2 pt-2">
                <a
                  href="#"
                  data-bs-target="#sidebar"
                  data-bs-toggle="collapse"
                  className=" p-1 text-decoration-none sidemenuicon"
                >
                  <GiHamburgerMenu />{" "}
                </a>

                <div className="tab-content" id="pills-tabContent p-3">
                  {/* register sub start------------------- */}
                  <div
                    className="tab-pane fade show active"
                    id="pills-1"
                    role="tabpanel"
                    aria-labelledby="pills-1-tab"
                  >
                    <div className="faqsub">
                      <div className="card mt-3">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingOneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseOneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseOneF"
                                      >
                                        How is the Forex market affected?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseOneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingOneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The Forex market is influenced by people&apos;s expectations for the future, which are shaped by various factors. Some companies hedge currency exposure to protect their financial interests, while key traders focus on economic indicators that impact the overall strength of economies. Meanwhile, technical traders analyze price patterns to determine their trades. Additionally, hedge funds, central banks, and financial institutions contribute to market dynamics, each with unique trading goals and perspectives.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingtwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsetwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwoF"
                                      >
                                        Are my money and personal data
                                        protected?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsetwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          All client funds are held in accounts with top-tier banks, guaranteeing the safety and security of your investments at all times. Additionally, we implement strict security measures to safeguard your personal information, ensuring complete confidentiality and protection.
                                        </p>

                                        {/* <p>
                                          {" "}
                                          We also ensure that your personal
                                          information is secure as well.
                                        </p> */}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThreeF"
                                      >
                                        Where can I find your Customer
                                        Agreement, Conditions, etc.?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can access our Customer Agreement, Terms, and other related documents on our Account Opening Agreements page. This section contains all the essential information regarding our business policies and conditions.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsefourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsefourF"
                                      >
                                        What can I do if none of my bills are in
                                        my name?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsefourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p className="strong">
                                          If you don’t have bills in your name, you can:
                                        </p>
                                        <p>
                                          Use your ID if it already shows your current address.
                                        </p>
                                        <p>
                                          Submit a bank/card statement, residence certificate, or a utility bill (gas, mobile, tenancy contract, etc.).
                                        </p>
                                        <p>
                                          Provide another ID with your address or a proof of residence from your landlord, parent, or spouse (labeled as &quot;Proof of Residence&quot;).
                                        </p>
                                        <p>
                                          If you have any queries, please
                                          contact at{" "}
                                          <span> <a href="mailto:support@millance.com" target="_blank" style={{ color: "inherit" }}>
                                            support@millance.com
                                          </a>.
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiveF"
                                      >
                                        How long does it take to check my
                                        profile?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Once you upload all required documents, your profile will be reviewed within 10 minutes to 24 hours during working hours.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixF"
                                      >
                                        What is Fundamental Analysis, And Why Is
                                        So Important?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Fundamental analysis is a research method that evaluates political, economic, and social factors influencing a country’s currency. It examines supply and demand dynamics affecting currencies, commodities, and stocks. Key influences include economic reports, geopolitical events, seasonal trends, interest rate changes, central bank policies, and other market-moving factors.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSevenF"
                                      >
                                        What Is Trade Management?                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Trade management refers to the process of managing open positions. It involves minimizing risk as a trade becomes profitable by adjusting the stop-loss closer to the market price or reducing potential losses on a trade.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightF"
                                      >
                                        Do you permit trading in the news?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>Yes, we do.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNineF"
                                      >
                                        Is it possible to earn as I study?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, your success depends on it. Start with a small, realistic goal and practice consistently.

                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  {/*  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTenF"
                                      >
                                        Do you accept customers from the United
                                        States?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, please accept our apologies for
                                          the inconvenience.
                                        </p>
                                      </div>
                                    </div>
                                  </div> */}

                                  <div className="modal-footer" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="tab-pane fade show active" id="pills-1" role="tabpanel" aria-labelledby="pills-1-tab">
                  <div className='faqsub'>
                    <div className='card'>
                      <div className='container-fluid'>
                        <div className='row'>
                          <div className='col-12 col-lg-6'>
                         






                          </div>

                        </div>
                      </div>
                    </div>

                  </div>
                </div> */}

                  <div
                    className="tab-pane "
                    id="pills-2"
                    role="tabpanel"
                    aria-labelledby="pills-2-tab"
                  >
                    <div className="faqsub">
                      <div className="card">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingLevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseLevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseLevenF"
                                      >
                                        How do I become a member of Millance LTD?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseLevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingLevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Visit https://www.millance.com, fill in the required details, and click &apos;Register Now.&apos; Check your email and click ‘Confirm Mail’ to activate your account.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTweleF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTweleF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTweleF"
                                      >
                                        How can I reset my Millance LTD password?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTweleF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTweleF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <span>
                                          <p className="stong">
                                            {" "}
                                            You can reset your password in
                                            simple steps:
                                          </p>
                                        </span>
                                        <p>
                                          {" "}
                                          Enter your email. Enter your new
                                          password.
                                        </p>
                                        <p>
                                          Simply enter your email and set a new password. Keep your password secure and do not share it with anyone.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtinF"
                                      >
                                        How can I change my home address details?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Submit a copy of your proof of residence document, and we will update your profile accordingly. You can find details on acceptable documents here.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFourtinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFourtinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFourtinF"
                                      >
                                        Where can I find my MARKET login details for Millance LTD?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFourtinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFourtinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You will receive an email with your login details shortly after registration. If you haven&apos;t received it, please use the reset password option.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftinF"
                                      >
                                        What should I do if I get an error while uploading documents?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <span>
                                          <p className="stong">
                                            {" "}
                                            Please check the following before uploading:
                                          </p>
                                        </span>
                                        <p>
                                          The document size should not exceed 2MB.
                                        </p>
                                        <p>
                                          The file must be in one of the following formats: GIF, JPG, TIFF, PNG, DOC, DOCX, or PDF.
                                        </p>
                                        <p>
                                          If the issue persists, please send your documents to
                                          <span>
                                            <a href="mailto:support@millance.com" target="_blank" style={{ color: "inherit" }}>
                                              support@millance.com
                                            </a>
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtinF"
                                      >
                                        How can I become a verified customer?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          To access Millance LTD’s trading platform and services, you need to verify your profile by uploading clear color copies of the following documents:
                                        </p>
                                        <p>
                                          <b>Proof of Identity –</b>  A national ID card, passport, or driver&apos;s license. If your ID document includes your correct residential address, an additional proof of address may not be required.
                                        </p>
                                        <p>
                                          •<b>Proof of Address –</b> – A bank/card statement or utility bill issued within the last six months.

                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventinF"
                                      >
                                        How can I change my email or phone number?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          {" "}
                                          To update your email or phone number in Millance LTD, go to your user profile page, click on &apos;Change&apos; under the &apos;Actions&apos; column, and follow the instructions.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightinF"
                                      >
                                        What is the Millance LTD dashboard, and how does it work?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The Millance LTD dashboard is your gateway to the platform. It allows you to open trading accounts, download trading platforms, upload verification documents, deposit and withdraw funds, sign up for webinars, and more.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNinetinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNinetinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNinetinF"
                                      >
                                        What does the error &quot;This number/email has already been registered&quot; mean?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNinetinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNinetinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          {" "}
                                          This error means that your phone number or email address is already registered with Millance LTD.
                                        </p>
                                        <p>
                                          If you forgot your password, you can reset it by following the provided steps. Remember, you can only have one Millance LTD account, but you can create multiple trading accounts and access various products and services within it.

                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTwentyF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwentyF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwentyF"
                                      >
                                        Can I change my account type?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTwentyF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwentyF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, but you can open a new account in the MT5 Area anytime and choose your preferred account type.

                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTwentyoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwentyoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwentyoneF"
                                      >
                                        Can I change my account&apos;s base currency?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTwentyoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwentyoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, the base currency of an existing trading account cannot be changed. However, you can open a new account in the Members Area and select your preferred base currency.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-3"
                    role="tabpanel"
                    aria-labelledby="pills-3-tab"
                  >
                    <div className="faqsub">
                      <div className="card">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTwentytwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwentytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwentytwoF"
                                      >
                                        How do I start trading Forex?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTwentytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwentytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Open a trading account with Millance LTD, one of the leading stock brokers. With our comprehensive services, you can start trading currencies in just a few minutes!
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTwentythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwentythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwentythreeF"
                                      >
                                        Do you provide binary options trading?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTwentythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwentythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>No, we don&apos;t.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTwentyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwentyfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwentyfourF"
                                      >
                                        Can I transfer funds between trading accounts?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTwentyfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwentyfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, you can request an internal transfer between two validated trading accounts registered under your name. If the accounts have different base currencies, the amount will be converted. You can initiate the transfer in the Transfer Area, and it will be processed immediately.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTwentyfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwentyfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwentyfiveF"
                                      >
                                        What is one-click trading, and how does it work?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTwentyfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwentyfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          One-click trading allows you to open positions instantly with a single click. However, closing a position requires manual confirmation. To enable one-click trading, click the arrow in the left corner of your chart, and a trading window will appear.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTwentysixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwentysixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwentysixF"
                                      >
                                        How to get into trading?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTwentysixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwentysixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Once you&apos;ve created a trading account, received your login details via email, submitted your identification documents for verification, and made a deposit, your next step is to download your preferred trading platform.{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTwentysevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwentysevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwentysevenF"
                                      >
                                        What is your execution model?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTwentysevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwentysevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The company operates as the principal, meaning it is the sole execution venue for customer orders. Additionally, when executing client orders, the company may route them to regulated financial institutions within and outside the EU.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTwentyeightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwentyeightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwentyeightF"
                                      >
                                        How long can I use a demo account?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTwentyeightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwentyeightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          There is no time limit for using a demo account on the Millance LTD trading platform. However, accounts inactive for more than 90 days from the last login will be closed. You can always open a new demo account if needed, with a maximum of five active demo accounts allowed at a time.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingTwentynineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseTwentynineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwentynineF"
                                      >
                                        Can a friend or family member trade on my behalf?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseTwentynineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwentynineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, only the account holder is allowed to trade. However, a third party may trade on behalf of the registered client if a Power of Attorney (POA) is submitted and approved by the company.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtyF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtyF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtyF"
                                      >
                                        If I lose the bonus, can I get it back?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtyF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtyF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Since the bonus is part of your equity and can be used for trading, it can be lost. However, as per the Bonus Terms and Conditions, you may receive a new bonus on your next deposit.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtyoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtyoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtyoneF"
                                      >
                                        If I trade in FOREX, will I lose all my assets?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtyoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtyoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, you won’t lose everything you own. However, traders with little knowledge are more likely to lose their margin account. Those who are well-informed have a better chance of profiting from less experienced traders.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-4"
                    role="tabpanel"
                    aria-labelledby="pills-4-tab"
                  >
                    <div className="faqsub">
                      <div className="card">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtytwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtytwoF"
                                      >
                                        Where is Forex, and who owns it?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Forex is a decentralized market, meaning no one owns it. It operates as an interbank market where transactions occur directly between buyers and sellers. As long as the banking system exists, Forex will continue to operate, independent of any single country or government.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtythreeF"
                                      >
                                        Where can you trade Forex?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          {" "}
                                          You can trade Forex from anywhere in the world.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtyfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtyfourF"
                                      >
                                        Can I acquire international stocks from Millance LTD?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtyfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtyfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, you can trade bonds and stocks from major exchanges, including the Tokyo Stock Exchange, London Stock Exchange (LSE), Hong Kong Stock Exchange (HKEX), and popular U.S. exchanges like NYSE, NASDAQ, NYMEX, and GLOBEX.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtyfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtyfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtyfiveF"
                                      >
                                        What currencies can you trade with Millance LTD?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtyfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtyfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can trade over 60+ currency pairs with Millance LTD, offering a wide range of investment options..
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtysixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtysixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtysixF"
                                      >
                                        How can I check my trade history?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtysixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtysixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Press Ctrl + T to open the terminal window and select Account History. Right-click to save your trade history as a .html file for later viewing, even after logging out.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtysevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtysevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtysevenF"
                                      >
                                        What is the difference between real and demo accounts?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtysevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtysevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A demo account offers the same features as a real account, but it does not replicate actual market conditions. Unlike real trading, demo trades do not impact the market, and large trade volumes in real accounts can influence prices. Execution speed remains the same for both. However, psychological factors differ trading with real money affects decision-making differently than a demo account. Be cautious when evaluating results from a demo account. More details on demo accounts are available here.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtyeightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtyeightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtyeightF"
                                      >
                                        How do emotions affect trading?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtyeightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtyeightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Emotions play a big role in trading. Many traders know the market well but struggle to control their feelings. To succeed, you must trade logically, not emotionally. No one wins every trade, not even professionals. The best traders stay calm, think logically, and make smart decisions based on strategy, not emotions.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingThirtynineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseThirtynineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThirtynineF"
                                      >
                                        What is good judgment trading?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseThirtynineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingThirtynineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Good judgment trading means understanding the market and its changing conditions. Instead of relying on automated systems, traders use a clear strategy based on high-probability opportunities. An educated trader avoids random decisions and takes a focused, precise approach to the market.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-5"
                    role="tabpanel"
                    aria-labelledby="pills-5-tab"
                  >
                    <div className="faqsub">
                      <div className="card">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFortyF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFortyF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFortyF"
                                      >
                                        What time does the Forex market open and close?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFortyF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFortyF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The Forex market opens at 22:00 GMT on Sunday (when the Australian session begins) and closes at 22:00 GMT on Friday (when the U.S. session ends).
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFortyoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFortyoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFortyoneF"
                                      >
                                        Do you provide corporate accounts?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFortyoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFortyoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          {" "}
                                          Yes, we offer corporate accounts.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFortytwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFortytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFortytwoF"
                                      >
                                        How do I buy and sell currency pairs?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFortytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFortytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can trade currencies easily using your tablet or smartphone. With the MetaTrader 5 mobile platform, you can access the Forex market anytime, anywhere. Simply download the app for free and manage your trades on the go!
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFortythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFortythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFortythreeF"
                                      >
                                        Why can&apos;t I log in to my trading account?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFortythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFortythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <span>
                                          <p>
                                            <b>&quot;No connection&quot; – </b>This means you have selected the wrong server.
                                          </p>
                                        </span>
                                        <span>
                                          <p>
                                            <b>&quot;Invalid account&quot; – </b>This indicates that you have entered an incorrect ID or password.
                                          </p>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFortyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFortyfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFortyfourF"
                                      >
                                        How do I change my trading account password?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFortyfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFortyfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Go to the Dashboard section of Millance LTD.
                                        </p>
                                        <p>
                                          Click the Deposit button for the account you want to update.{" "}
                                        </p>
                                        <p>Select Change Password Trade.</p>
                                        <p>
                                          Click Next and enter the PIN sent to your email or SMS.
                                        </p>
                                        <p>
                                          Create a new password and click Submit.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFortyfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFortyfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFortyfiveF"
                                      >
                                        Does slippage occur with Millance LTD?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFortyfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFortyfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Slippage is rare when trading with us. However, during major news releases or high market volatility, your order may be executed at a slightly different price than requested due to rapid price fluctuations.{" "}
                                        </p>
                                        {/* <p>
                                          <b>World’s biggest stock broker</b>,
                                          Millance LTD fulfills your orders at the
                                          market price, which is in value.
                                        </p> */}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFortysixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFortysixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFortysixF"
                                      >
                                        What is a Stop Loss, and How Does It Work?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFortysixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFortysixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A stop-loss order automatically closes an open position when the price reaches a predetermined level, limiting potential losses. It acts as a safety cap on your trade, ensuring your order is closed when the market moves against you.{" "}
                                        </p>
                                        <p>
                                          When setting stop/limit orders, you must maintain a certain distance from the current market price. For BUY orders, stop-loss points are placed below the current BID price, while for SELL orders, they are set above the current ASK price.{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFortysevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFortysevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFortysevenF"
                                      >
                                        Why Isn&apos;t Forex More Widely Known?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFortysevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFortysevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Historically, Forex trading was dominated by major investors, banks, financial institutions, and governments. However, with the rise of the internet, more individuals are now learning about Forex and exploring its opportunities.{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFortyeightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFortyeightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFortyeightF"
                                      >
                                        What is Technical Analysis?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFortyeightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFortyeightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Technical analysis involves studying historical price movements to predict future market trends. This is done using various indicators and analytical tools to identify support and resistance levels, trends, and potential price changes.{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFortynineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFortynineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFortynineF"
                                      >
                                        What Does the Market Traders Institute Offer?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFortynineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFortynineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          By joining, you&apos;ll learn from experienced traders and a trusted company. We provide comprehensive training, ongoing personal support, market research, and educational resources to help you succeed. As you advance, you can access advanced trading courses. If the program doesn’t meet your expectations, we offer a refund for the course cost.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-6"
                    role="tabpanel"
                    aria-labelledby="pills-6-tab"
                  >
                    <div className="faqsub">
                      <div className="card">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftyF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftyF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftyF"
                                      >
                                        What Trading Instruments Are Available?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftyF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftyF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can explore the complete list of trading instruments we offer here.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftyoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftyoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftyoneF"
                                      >
                                        Is there scalping?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftyoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftyoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>Yes.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftytwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftytwoF"
                                      >
                                        Is there hedging?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>Yes.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftythreeF"
                                      >
                                        How to Open a Live or Demo Account with Millance LTD?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Log in to My Millance LTD and go to the &quot;MT5&quot; tab.
                                        </p>
                                        <p>
                                          Select the account type you want to open and click &quot;Open New Account.&quot;
                                        </p>
                                        <p>
                                          Fill in the required details and click &quot;Open Account.&quot;
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftyfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftyfourF"
                                      >
                                        What are your spreads?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftyfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftyfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          We offer floating spreads across all our accounts. For more details, please check our contract specification page.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftyfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftyfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftyfiveF"
                                      >
                                        What kind of lots do you offer?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftyfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftyfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>We offer Standard, Mini, and Micro lots.</p>
                                        <p>
                                          For more details, please visit our contract specification page.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftysixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftysixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftysixF"
                                      >
                                        How many trading accounts can I open?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftysixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftysixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          {" "}
                                          There are no limits, you can open as many accounts as you like.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftysevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftysevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftysevenF"
                                      >
                                        What types of trading accounts can I open?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftysevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftysevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          {" "}
                                          You can view all your demo, live, and investment accounts, along with wallets, in the Accounts Overview section of My Millance LTD.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftyeightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftyeightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftyeightF"
                                      >
                                        What leverage do you offer?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftyeightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftyeightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          We offer a maximum leverage of 1:100.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingFiftynineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseFiftynineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseFiftynineF"
                                      >
                                        What is the leverage for precious metals like Gold and Silver?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseFiftynineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingFiftynineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>The maximum leverage available is 1:100.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtyF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtyF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtyF"
                                      >
                                        What is the maximum trading volume allowed?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtyF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtyF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The maximum trading volume is 100 lots, depending on your investment.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtyoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtyoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtyoneF"
                                      >
                                        What is your Limit & Stop Level?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtyoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtyoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The limit and stop level is one spread, with a 20% stop-out level.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtytwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtytwoF"
                                      >
                                        What is a read-only password?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A read-only password is a public password that allows others to view your trading results without granting any trading permissions.
                                        </p>
                                        <p>
                                          Note: Your read-only password should be different from your trading account password.
                                        </p>

                                        {/* need update contents  */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-7"
                    role="tabpanel"
                    aria-labelledby="pills-7-tab"
                  >
                    <div className="faqsub">
                      <div className="card">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtythreeF"
                                      >
                                        What&apos;s XAU?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          XAU is the ticker symbol for Gold (XAU/USD).
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtyfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtyfourF"
                                      >
                                          What is FOMO?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtyfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtyfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          FOMO stands for Fear of Missing Out, a common emotional challenge for inexperienced traders.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtyfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtyfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtyfiveF"
                                      >
                                        What is WTI?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtyfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtyfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          WTI refers to West Texas Intermediate, a type of crude oil.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtysixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtysixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtysixF"
                                      >
                                        What is US30 or DJ30?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtysixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtysixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          These ticker symbols represent the Dow Jones Industrial Average (DJIA).
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtysevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtysevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtysevenF"
                                      >
                                        What is NFP?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtysevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtysevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>NFP stands for Non-Farm Payroll, a key economic indicator.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtyeightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtyeightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtyeightF"
                                      >
                                        What is RR?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtyeightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtyeightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>RR stands for Reward/Risk ratio, used to evaluate trade potential.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSixtynineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSixtynineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSixtynineF"
                                      >
                                        What is FOMC?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSixtynineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSixtynineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          {" "}
                                          The Federal Open Market Committee (FOMC) sets monetary policy in the U.S.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventyF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventyF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventyF"
                                      >
                                        What are correlated pairs?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventyF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventyF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          These are currency pairs that move in the same direction, such as EUR/USD and GBP/USD or NZD/USD and AUD/USD.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventyoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventyoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventyoneF"
                                      >
                                        What is an Inside Day?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventyoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventyoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          It refers to a daily candlestick with a lower high and higher low than the previous day&apos;s candle, often signaling a trend continuation.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventytwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventytwoF"
                                      >
                                        Can I trade in volatile markets?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, but it carries higher risk.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventythreeF"
                                      >
                                        Do you change spreads during news releases?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Spreads may increase due to market volatility, as determined by liquidity providers.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventyfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventyfourF"
                                      >
                                        Do you provide news on your platform?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventyfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventyfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>Yes, market news is available.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventyfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventyfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventyfiveF"
                                      >
                                        Can I use bots or expert advisors (EAs)?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventyfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventyfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, all our trading platforms support EAs.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventysixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventysixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventysixF"
                                      >
                                        How can I add an expert advisor?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventysixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventysixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Open the MT5 Client Terminal.
                                        </p>
                                        <p>Click File {'>'}Open Data Folder.</p>
                                        <p>Navigate to MQL5 {">"} Experts.</p>
                                        <p>Paste the .mq5 or .ex5 EA file into the Experts folder.</p>
                                        <p>Restart MT5 to apply changes.</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventysevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventysevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventysevenF"
                                      >
                                        Can I use the Expert Advisors (EAs) system?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventysevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventysevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>Yes, EAs are supported.</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventyeightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventyeightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventyeightF"
                                      >
                                        How can I open a new trade/position?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventyeightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventyeightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Go to Tools {">"} New Order in your trading platform and enter the required details.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingSeventynineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseSeventynineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseSeventynineF"
                                      >
                                        How can I close an open position?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseSeventynineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingSeventynineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Right-click or double-click on the trade.
                                        </p>
                                        <p>
                                          Click Close Order and confirm by clicking OK.
                                        </p>
                                        <p>
                                          Check closed positions in the Account History tab.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightyF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightyF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightyF"
                                      >
                                        Can I set trailing stop orders?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightyF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightyF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>Yes, trailing stop orders are available.</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightyoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightyoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightyoneF"
                                      >
                                        Can I hold long and short positions at the same time?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightyoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightyoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>Yes, this is known as hedging.</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightytwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightytwoF"
                                      >
                                        How can I check my trading strategy?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can test your strategy by:
                                        </p>
                                        <p>Opening a demo trading account.</p>
                                        <p>Reviewing past price data to assess trade performance.</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightythreeF"
                                      >
                                        How can I develop a successful trading strategy?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Try different trading styles and techniques.
                                        </p>
                                        <p>Backtest strategies before using them in live trading.</p>
                                        <p>Choose a strategy that suits your trading personality.</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightyfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightyfourF"
                                      >
                                        How do I calculate my free margin?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightyfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightyfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>Free Margin = Equity – Used Margin</p>
                                        <p>
                                          Free Margin = (Equity × Exposure) - Used Margin
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-8"
                    role="tabpanel"
                    aria-labelledby="pills-8-tab"
                  >
                    <div className="faqsub">
                      <div className="card mt-3">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightyfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightyfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightyfiveF"
                                      >
                                        Where can I find my trading account login information?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightyfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightyfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Your login details will be sent to your registered email. You can also reset your password anytime.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightysixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightysixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightysixF"
                                      >
                                        How can I get news updates on my trading platform?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightysixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightysixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Sign in to your platform.
                                        </p>
                                        <p>
                                          Navigate to Tools {">"} Options.
                                        </p>
                                        <p>
                                          Select Server and check the Enable News box.
                                        </p>
                                        <p>
                                          Click OK to apply changes.
                                        </p>
                                        <p><b>Note:</b>Be cautious of heavy economic announcements, as enabling the news tab may slow down your platform.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightysevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightysevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightysevenF"
                                      >
                                        Why am I seeing an ‘Invalid Parameters’ error?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightysevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightysevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          This occurs when the Lot Size, Stop Loss, or Take Profit settings are incorrect.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightyeightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightyeightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightyeightF"
                                      >
                                        What is Day Trading?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightyeightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightyeightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p className="strong">
                                          Day trading involves buying and selling assets within the same trading day to capitalize on short-term price movements.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingEightynineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseEightynineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseEightynineF"
                                      >
                                        Can I use indicators on my mobile trading platform?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseEightynineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingEightynineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes. Tap the ‘f’ symbol in the chart window to display indicators.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintyF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintyF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintyF"
                                      >
                                        What does ‘Authentication Fail’ mean?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintyF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintyF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          This means your user ID or password is incorrect.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintyoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintyoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintyoneF"
                                      >
                                        What types of spreads do you offer?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintyoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintyoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          We provide variable spreads starting as low as 0.9 pips. Our clients receive the best market prices instantly.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintytwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintytwoF"
                                      >
                                        What are short and long positions?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Long Position: Buying an asset, profiting when its price increases.
                                        </p>
                                        <p>Short Position: Selling an asset, profiting when its price decreases.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintytwoF"
                                      >
                                        What is margin?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Margin is the amount of money required in your broker account to maintain an open position. Different brokers require different margin levels.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintythreeF"
                                      >
                                        Do you allow hedging?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, you can hedge your positions. Hedging occurs when you simultaneously open both LONG and SHORT positions on the same instrument.
                                        </p>
                                        <p>
                                          <b>Note:</b>
                                          Hedging is permitted for Forex, Gold, and Silver, even when the margin level falls below 100%, as the margin requirement is zero.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintythreeF"
                                      >
                                        Do you allow scalping?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>Yes, scalping is permitted.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintyfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintyfourF"
                                      >
                                        What do Swing High and Swing Low mean?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintyfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintyfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Swing High: A three-bar pattern where the middle candle forms the highest point, with the two adjacent candles closing lower.
                                        </p>
                                        <p>Swing Low: The opposite pattern, where the middle candle forms the lowest point.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintyfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintyfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintyfiveF"
                                      >
                                        What is a trading day?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintyfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintyfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A trading day refers to any trade that is opened and closed within the same day.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintysixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintysixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintysixF"
                                      >
                                        What is an Up Candle?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintysixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintysixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          An Up Candle is another term for a Bullish Candle, indicating price increases.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintysevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintysevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintysevenF"
                                      >
                                        What is a Down Candle?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintysevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintysevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A Down Candle is another term for a Bearish Candle, indicating price declines.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-9"
                    role="tabpanel"
                    aria-labelledby="pills-9-tab"
                  >
                    <div className="faqsub">
                      <div className="card mt-3">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintyeightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintyeightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintyeightF"
                                      >
                                        What are &apos;LOTS&apos;?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintyeightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintyeightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        Lots refer to the units used in forex trading. The three types of lots are:

                                        <p>
                                          Micro Lot (0.01) = Controls 1,000 currency units
                                        </p>
                                        <p>Mini Lot (0.10) = Controls 10,000 currency units</p>
                                        <p>Standard Lot (1.00) = Controls 100,000 currency units</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintynineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintynineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintynineF"
                                      >
                                        What is a WICK?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintynineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintynineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The wick is the vertical line extending above and below the candlestick’s body, representing price highs and lows.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNinetyF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNinetyF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNinetyF"
                                      >
                                        What is a CANDLESTICK?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNinetyF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNinetyF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        A candlestick is a price charting method that shows currency price movements. Each candlestick represents a specific time period, such as:
                                        <p>
                                          M5 (5 minutes) = Each candle covers 5 minutes
                                        </p>
                                        <p>D1 (Daily) = Each candle covers 24 hours</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintyoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintyoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintyoneF"
                                      >
                                        What is the value of a PIP?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintyoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintyoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        If your account is in USD and you&apos;re trading a USD-based pair:
                                        <p className="strong">
                                          Micro Lot (0.01) = $0.10 per pip
                                        </p>
                                        <p className="strong">Mini Lot (0.10) = $1.00 per pip</p>
                                        <p className="strong">Standard Lot (1.00) = $10.00 per pips</p>

                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintytwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintytwoF"
                                      >
                                        What is BULLISH?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A bullish market means you expect a currency pair to rise in value. Example: Being bullish on USD/INR means you expect the USD to appreciate against INR.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintythreeF"
                                      >
                                        What is BEARISH?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A bearish market means you expect a currency pair to decline in value. Example: Being bearish on EUR/USD means you expect the EUR to weaken against the USD.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintyfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintyfourF"
                                      >
                                        What is a LIMIT ORDER?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintyfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintyfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        A limit order allows you to enter a position only at a specific price.
                                        <p>
                                          Buy Limit: Executes when the market price falls to your set price (below the current price).
                                        </p>
                                        <p>Sell Limit: Executes when the market price rises to your set price (above the current price).</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintyfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintyfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintyfiveF"
                                      >
                                        What is a MARKET ORDER?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintyfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintyfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A market order is an immediate buy or sell at the current market price.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintysixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintysixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintysixF"
                                      >
                                        What is Leverage?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintysixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintysixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        Leverage allows traders to control large positions with a smaller capital amount.
                                        <p>
                                          Example: With a 100:1 leverage, a $1,000 account can control a $100,000 trade.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintysevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintysevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintysevenF"
                                      >
                                        What is a STOP ORDER?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintysevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintysevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        A stop order converts into a market order once the specified price is reached.
                                        <p>
                                          Buy Stop: Executes a buy order when the price moves above the set level.
                                        </p>
                                        <p>Sell Stop: Executes a sell order when the price drops below the set level.</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintyeightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintyeightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintyeightF"
                                      >
                                        What is Margin?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintyeightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintyeightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        Margin is the minimum amount required in your account to open a trade.
                                        <p>
                                          Example: A $1,000 margin at 100:1 leverage means you can control a $100,000 position.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingNintynineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseNintynineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseNintynineF"
                                      >
                                        What is a Margin Level?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseNintynineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingNintynineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The margin level is a percentage indicating the health of your account. If it drops too low, your broker may close your trades.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredF"
                                      >
                                        What is a Margin Call?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A margin call occurs when your account lacks sufficient funds to support open trades, forcing the broker to liquidate positions.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredoneF"
                                      >
                                        What is the Fibonacci Tool?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Fibonacci is a technical analysis tool used to measure retracement and extension levels based on price movements.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredtwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredtwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredtwoF"
                                      >
                                        What is Your Leverage?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredtwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredtwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>Leverage varies depending on your account equity.</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredthreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredthreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredthreeF"
                                      >
                                        What is Support & Resistance (S&R)?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredthreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredthreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Support: A price level where an asset tends to stop falling and bounce back up.
                                        </p>
                                        <p>Resistance: A price level where an asset tends to stop rising and reverse downward.</p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredfourF"
                                      >
                                        What is Fibonacci Retracement?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A retracement measures price pullbacks in percentage terms, indicating possible reversal levels.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredfiveF"
                                      >
                                        What is Risk Management?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Risk management involves strategies to minimize losses. A common rule is to risk no more than 2% of your account per trade.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredsixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredsixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredsixF"
                                      >
                                        What is a Swap-Free Fee?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredsixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredsixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          A swap-free fee is a charge applied when keeping positions open beyond a certain period. Details can be found in the Contract Specifications section.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-10"
                    role="tabpanel"
                    aria-labelledby="pills-10-tab"
                  >
                    <div className="faqsub">
                      <div className="card mt-3">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredsevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredsevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredsevenF"
                                      >
                                        How much capital do I need to start forex trading?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredsevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredsevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can start forex trading with as little as $10.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredeightF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredeightF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredeightF"
                                      >
                                        How can I withdraw money from my account?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredeightF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredeightF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Go to the &apos;Wallet&apos; section in My Millance and navigate to &apos;Withdraw.&apos; Choose your preferred payment method and click the &apos;Draw&apos; button. Select the wallet from which you want to withdraw funds, fill in the required details, choose a withdrawal reason, enter the PIN received via email or SMS, and click &apos;submit.&apos; Ensure your profile is fully verified before making a withdrawal request.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundrednineF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundrednineF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundrednineF"
                                      >
                                        What should I do if I lose my card?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundrednineF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundrednineF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You need to provide an official document from the card issuer confirming that your card has been lost or canceled. Once we receive it, we will guide you on the next steps.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredtenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredtenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredtenF"
                                      >
                                        Are there any extra steps for withdrawing via an e-wallet?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredtenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredtenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p className="strong">
                                          If your e-wallet has already been verified, your withdrawal will be processed automatically.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredlevenF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredlevenF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredlevenF"
                                      >
                                        Can I withdraw funds while having an open position?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredlevenF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredlevenF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, as long as you have enough free margin in your account to cover the withdrawal and any applicable fees.
                                        </p>

                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredtwelveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredtwelveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredtwelveF"
                                      >
                                        How long does it take for my withdrawal to be processed?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredtwelveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredtwelveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Our Back Office Department processes all withdrawal requests within 24 hours. However, the time it takes for funds to reach your account depends on the payment method used.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredthirtinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredthirtinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredthirtinF"
                                      >
                                        Do I need to follow specific steps when withdrawing via a local payment solution?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredthirtinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredthirtinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, ensure that you have previously used the same payment method for depositing funds.
                                        </p>

                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredfourtinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredfourtinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredfourtinF"
                                      >
                                        How can I transfer money between my trading accounts?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredfourtinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredfourtinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Go to the &apos;Internal Transfer&apos; section in My Millance LTD &apos;Wallet.&apos; Select the amount and the account to which you want to transfer funds, then click &apos;Confirm.&apos;
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredfiftinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredfiftinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredfiftinF"
                                      >
                                        Are there any restrictions on internal transfers?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredfiftinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredfiftinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can transfer funds between your trading accounts, and transfers can be made in the available currencies. Internal transfers have no minimum or maximum limit. You will receive an email confirmation before the transfer is processed.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredsixtinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredsixtinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredsixtinF"
                                      >
                                        Do you charge internal transfers?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredsixtinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredsixtinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, internal transfers are completely free.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredseventinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredseventinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredseventinF"
                                      >
                                        How long does it take to process an internal transfer?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredseventinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredseventinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Internal transfers are usually processed within minutes. If there is a delay, please contact our Back Office department.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredeightinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredeightinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredeightinF"
                                      >
                                        What should I do if my deposit or withdrawal is declined?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredeightinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredeightinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          If your deposit is declined, you should receive an email explaining the reason. You can also check the status of your deposit or withdrawal in My Millance LTD.
                                        </p>

                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundrednintinF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundrednintinF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundrednintinF"
                                      >
                                        Why do internal transfers get declined?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundrednintinF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundrednintinF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          This usually happens due to insufficient free margin in your account.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredtwentyF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredtwentyF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredtwentyF"
                                      >
                                        What does &apos;card decline&apos; mean?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredtwentyF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredtwentyF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p className="strong">
                                          Your request may be declined for one of the following reasons:

                                        </p>
                                        <p>
                                          1. Insufficient balance.
                                        </p>
                                        <p>
                                          2.No trading activity since your last deposit.
                                        </p>
                                        <p>3. Incorrect account details. </p>
                                        <p>
                                          4. The withdrawal method differs from the original deposit method.{" "}
                                        </p>
                                        <p>
                                          5. Credit/debit card withdrawal exceeds the deposited amount.{" "}
                                        </p>
                                        <p>
                                          6. Missing required information.{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredtwentyoneF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredtwentyoneF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredtwentyoneF"
                                      >
                                        What should I do if my e-wallet or local payment withdrawal is not received?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredtwentyoneF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredtwentyoneF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          If you haven’t received your withdrawal, please contact our Back Office department for further assistance.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredtwentytwoF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredtwentytwoF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredtwentytwoF"
                                      >
                                        What deposit and withdrawal methods do you offer?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredtwentytwoF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredtwentytwoF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Millance LTD provides various payment methods, including credit and debit cards, bank wire transfers, e-wallets, and local payment solutions.{" "}
                                        </p>

                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredtwentythreeF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredtwentythreeF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredtwentythreeF"
                                      >
                                        Do you accept cash deposits?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredtwentythreeF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredtwentythreeF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, we do not accept cash deposits.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-11"
                    role="tabpanel"
                    aria-labelledby="pills-11-tab"
                  >
                    <div className="faqsub">
                      <div className="card mt-3">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredtwentyfourF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredtwentyfourF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredtwentyfourF"
                                      >
                                        Why is my account balance different from
                                        what I have deposited?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredtwentyfourF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredtwentyfourF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          It may be due to additional charges
                                          incurred by your payment
                                          provider/bank. Please contact our
                                          payment processor for further
                                          clarification if this is the case, as
                                          we do not have access to third-party
                                          service systems.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredtwentyfiveF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredtwentyfiveF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredtwentyfiveF"
                                      >
                                        How to make deposits using local payment
                                        solutions?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredtwentyfiveF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredtwentyfiveF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Contact our dedicated account service
                                          manager for step-by-step information
                                          on depositing using local payment
                                          solutions.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingHundredtwentysixF"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseHundredtwentysixF"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseHundredtwentysixF"
                                      >
                                        Why is my request for a deposit get
                                        refused?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseHundredtwentysixF"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingHundredtwentysixF"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p className="strong">
                                          Your request may have been rejected
                                          for one of the reasons given below:{" "}
                                        </p>
                                        <p>
                                          - Card hasn&apos;t been active for online
                                          activities for some time.{" "}
                                        </p>
                                        <p>
                                          - Payment declined by card issuer-3D
                                          security (Credit/Debit Card).{" "}
                                        </p>
                                        <p>- Incorrect card details. </p>
                                        <p>- System Error. </p>
                                        <p>- Invalid email of the user. </p>
                                        <p>
                                          - Closed Account-Miscellaneous account
                                          number.{" "}
                                        </p>
                                        <p>
                                          - Miscellaneous purpose of payment
                                          (bank – wire).{" "}
                                        </p>
                                        <p>
                                          - Information of invalid recipients.{" "}
                                        </p>
                                        <p>
                                          Don&apos;t hesitate to contact your Account
                                          Service Manager, Customer Support, or
                                          Back Office if you need further
                                          clarification.{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingfourXX"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsefourXX"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsefourXX"
                                      >
                                        Can I deposit using a method that isn&apos;t
                                        in my name?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsefourXX"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingfourXX"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p className="strong">
                                          No, we do not accept transfers from
                                          third parties. The sender&apos;s name must
                                          match the name used to register with
                                          Millancee LTD.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingthreeXX"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsethreeXX"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsethreeXX"
                                      >
                                        Who&apos;s allowed to use wallets?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsethreeXX"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingthreeXX"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>All Millance LTD registered customers.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingfiveXX"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsefiveXX"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsefiveXX"
                                      >
                                        Can I deposit if the current balance is
                                        negative?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsefiveXX"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingfiveXX"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, you can. Please get in touch with
                                          Customer Support or our Back Office
                                          Department to correct the negative
                                          balance on your account.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingsixXX"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsesixXX"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsesixXX"
                                      >
                                        Can I use a corporate account to deposit
                                        to my trading account?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsesixXX"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingsixXX"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The deposit may be processed if you
                                          are the sole shareholder, but the
                                          withdrawal must be returned to the
                                          same bank account as the initial
                                          deposit.
                                        </p>
                                        <p>
                                          If there are several shareholders: we
                                          need the written consent of all
                                          shareholders. Once written permission
                                          has been received, the funds will be
                                          processed. If a withdrawal is
                                          requested, the funds will be returned
                                          to the same bank account as the
                                          initial deposit.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingsevenXX"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsesevenXX"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsesevenXX"
                                      >
                                        Which countries do you permit local
                                        payment solutions in?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsesevenXX"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingsevenXX"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          We offer a variety of local payment
                                          solutions for different countries; you
                                          can find a complete list of these
                                          options on Millance LTD.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingeightXX"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseeightXX"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseeightXX"
                                      >
                                        What are wallets?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseeightXX"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingeightXX"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Wallets are created so that when you
                                          open your MY Millance LTD account. Wallets
                                          can be used to make deposits,
                                          withdrawals, and internal transfers to
                                          and from your trading account in
                                          different currencies or to invest.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingnineXX"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsenineXX"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsenineXX"
                                      >
                                        Where can I find the status of my
                                        deposit/ withdrawal of internal
                                        transfer?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsenineXX"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingnineXX"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can find full details of your
                                          transactions in the History section by
                                          following the steps below.
                                        </p>
                                        <p>
                                          Go to the Transaction History section.
                                        </p>
                                        <p>Find the transaction in question.</p>
                                        <p>
                                          Click on the number of the transaction
                                          ID.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingtenXX"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsetenXX"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsetenXX"
                                      >
                                        How can I deposit the money into my
                                        account?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsetenXX"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingtenXX"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Open the Deposit page in the My
                                          Millance LTD Deposit section.
                                        </p>
                                        <p>
                                          Select the deposit method you prefer
                                          and click the Deposit button.
                                        </p>
                                        <p>
                                          Choose your wallet and fill out the
                                          fields you want to deposit money.
                                        </p>
                                        <p>
                                          Confirm on the next page your deposit
                                          information. You can ask your payment
                                          provider for some additional steps.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingelevenXX"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseelevenXX"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseelevenXX"
                                      >
                                        How long does it take to process the
                                        deposit?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseelevenXX"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingelevenXX"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Details about the processing time for
                                          each payment method can be found on
                                          the Deposits and Withdrawals page{" "}
                                        </p>
                                        <p>
                                          The processing time may take a while
                                          if we need to verify additional
                                          information. Please note that Millance LTD
                                          is not liable for any delays caused by
                                          the third-party payment processor.{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingtwelveXX"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsetwelveXX"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsetwelveXX"
                                      >
                                        When will it be processed if I deposit
                                        on the weekend or bank holiday?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsetwelveXX"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingtwelveXX"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The deposits made during the
                                          weekend/bank holidays shall be
                                          processed according to the standard
                                          processing times for each payment
                                          method.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-12"
                    role="tabpanel"
                    aria-labelledby="pills-12-tab"
                  >
                    <div className="faqsub">
                      <div className="card mt-3">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingOneXY"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseOneXY"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseOneXY"
                                      >
                                        Can I withdraw money if I have an open position?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseOneXY"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingOneXY"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, you can. However, certain restrictions apply to ensure the safety of our clients&apos; business.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingtwoXY"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsetwoXY"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwoXY"
                                      >
                                        What payment options are available for deposits and withdrawals?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsetwoXY"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwoXY"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          <b>
                                            Millance LTD offers a wide range of payment options for deposits and withdrawals, including:
                                          </b>
                                        </p>
                                        <li>Multiple credit cards</li>
                                        <li>
                                          Various electronic payment methods
                                        </li>
                                        <li>Bank wire transfers</li>
                                        <li>Local bank transfers</li>
                                        <li>Cryptocurrency transactions</li>
                                        <li>Other available payment methods</li>
                                        <p>
                                          The payment method used for deposits should be the same as for withdrawals. Once you open a trading account, you can log in to our wallet area, select your preferred payment method on the Deposits/Withdrawals page, and follow the provided instructions.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingtenXY"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsetenXY"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsetenXY"
                                      >
                                        Will you inform the tax authorities if I make a profit?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsetenXY"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingtenXY"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Yes, but only if required by regional legislation or regulations.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingfourXY"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsefourXY"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsefourXY"
                                      >
                                        Do I need to pay taxes on my profits?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsefourXY"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingfourXY"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p className="strong">
                                          Tax obligations are your responsibility. Please refer to the applicable laws in your region or seek independent financial advice.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingthreeXY"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsethreeXY"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsethreeXY"
                                      >
                                        Can I lose the money I deposited?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsethreeXY"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingthreeXY"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, you will not lose your deposited funds. If a currency pair slippage causes a negative balance, it will be automatically reset with your next deposit.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="modal-footer" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-13"
                    role="tabpanel"
                    aria-labelledby="pills-13-tab"
                  >
                    <div className="faqsub">
                      <div className="card mt-3">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingOneXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseOneXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseOneXYZ"
                                      >
                                        What is the procedure to become a member of your partnership?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseOneXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingOneXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can register as a broker or affiliate by visiting the Millance LTD Partners website.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingtwoXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsetwoXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwoXYZ"
                                      >
                                        Is there any registration fee to join?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsetwoXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwoXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, there is no registration fee for joining.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingtenXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsetenXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsetenXYZ"
                                      >
                                        What is a referral link?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsetenXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingtenXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          It is a unique connection between all affiliates and introducing brokers. Once a client registers using your link, they will be assigned to you.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingfourXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsefourXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsefourXYZ"
                                      >
                                        Can I track my referrals?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsefourXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingfourXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p className="strong">
                                          Yes, by clicking &apos;My Reports,&apos; you can view a full report of your referrals in your IB/Affiliate panel.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingthreeXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsethreeXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsethreeXYZ"
                                      >
                                        Can I be both an Introducing Broker and an Affiliate at the same time?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsethreeXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingthreeXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, you can only choose one program. For details on benefits and features, please refer to the Affiliates and Introducing Broker pages.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingfourXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsefourXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsefourXYZ"
                                      >
                                        What are the options for withdrawing my commissions/rebates?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsefourXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingfourXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Go to your Affiliate/IB panel and click &apos;Fund Withdrawal.&apos;
                                        </p>
                                        <p>
                                          Select a withdrawal method and complete the required fields.
                                        </p>
                                        <p>
                                          Click the &apos;Confirm&apos; button to submit your request.
                                        </p>
                                        <p>
                                          Please note that your Affiliate/IB profile must be verified before making a withdrawal.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingfiveXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsefiveXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsefiveXYZ"
                                      >
                                        Are there any limits on how much I can earn in a month?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsefiveXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingfiveXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, your monthly earnings are unlimited. The more active your clients are, the more you can earn.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingsixXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsesixXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsesixXYZ"
                                      >
                                        Is there a minimum payout requirement?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsesixXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingsixXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, you will still receive a payout even if your clients have earned you only a few cents.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingsevenXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsesevenXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsesevenXYZ"
                                      >
                                        Are there any restrictions on how long a client can remain under me?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsesevenXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingsevenXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          No, there is no time limit. You will continue earning as long as your client trades with Millance LTD.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingeightXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseeightXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseeightXYZ"
                                      >
                                        Who is eligible to become an Introducing Broker?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseeightXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingeightXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          The IB program is designed for individuals looking to expand their business and have a strong network of clients, such as strategy providers, coaches, forex instructors, or regional representatives.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingnineXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsenineXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsenineXYZ"
                                      >
                                        When can I start referring clients?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsenineXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingnineXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can start referring clients as soon as you register by sharing your referral link.
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingtenXYZ"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsetenXYZ"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsetenXYZ"
                                      >
                                        What do I need to do to become a verified IB?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsetenXYZ"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingtenXYZ"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          Fill out the form in the &apos;Personal Details&apos; section of your IB panel.
                                        </p>
                                        <p>
                                          Upload a valid photo ID, such as a passport, ID card, or driver’s license.
                                        </p>
                                        <p>Provide a Proof of Residence document (POR).</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="modal-footer" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane"
                    id="pills-14"
                    role="tabpanel"
                    aria-labelledby="pills-14-tab"
                  >
                    <div className="faqsub">
                      <div className="card mt-3">
                        <div className="container-fluid">
                          <div className="row">
                            <div className="col-12 col-lg-12">
                              <div className="modal-body">
                                <div
                                  className="accordion accordion-flush"
                                  id="accordionFlushExample"
                                >
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingOne123"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseOne123"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseOne123"
                                      >
                                        What instruments can I trade on MT5?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseOne123"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingOne123"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          You can trade all the instruments available at Millance LTD on the MT5 platform, including Stocks, Forex, Stock Indices, Precious Metals, Crypto, and Energies.
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingtwo123"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsetwo123"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseTwo123"
                                      >
                                        How can I view all trading pairs?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsetwo123"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingTwo123"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          <b>Log in to your MT5 platform.</b>{" "}
                                        </p>
                                        <li>Go to &quot;Market Watch.&quot; </li>
                                        <li> Right-click and select &quot;Show All.&quot; </li>
                                        <li> Scroll down to view all available trading pairs and tools. </li>

                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingten123"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapseten123"
                                        aria-expanded="false"
                                        aria-controls="flush-collapseten123"
                                      >
                                        What operating system (OS) do I need for MT5?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapseten123"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingten123"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p> <b>Windows:</b> Compatible from Windows 7 onwards.</p>
                                        <p><b>Mac:</b> Compatible from Mac OS X onwards.</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2
                                      className="accordion-header"
                                      id="flush-headingfour123"
                                    >
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#flush-collapsefour123"
                                        aria-expanded="false"
                                        aria-controls="flush-collapsefour123"
                                      >
                                        What trading platforms are available?
                                      </button>
                                    </h2>
                                    <div
                                      id="flush-collapsefour123"
                                      className="accordion-collapse collapse"
                                      aria-labelledby="flush-headingfour123"
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <p>
                                          {" "}
                                          MT5 is available on desktop, mobile, and iOS devices.
                                        </p>

                                      </div>
                                    </div>
                                  </div>

                                  <div className="modal-footer" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* register sub end------------------- */}

                  {/* tab-table 5 end------------------------------------------ */}
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq2;
